import lightbox from './glightbox';

class EventTeaser {
  constructor(node) {
    this.rootElement = node;
    this.eventId = this.rootElement.getAttribute('data-event-available-dates');
    this.rootElement.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    event.preventDefault();

    lightbox.setElements([
      {
        'content': document.querySelector(`${this.eventId}`)
      }
    ]);

    lightbox.open();
  }
}

const availableDates = document.querySelectorAll('[data-event-available-dates]');
availableDates.forEach((availableDate) => {
  new EventTeaser(availableDate);
});
